import { Typography } from '@mui/material';
import * as React from 'react';
import { ChannelItemWebPush } from '../../../../sic-lib/types/ChannelItem';

interface Props {
    channelItem: ChannelItemWebPush;
}

export default React.memo(function ConversationListItemWebPush({ channelItem }: Props) {
    return (
        <Typography variant="body1" display="block" whiteSpace="pre-wrap" p={2}>
            {channelItem.body}
        </Typography>
    );
});
